import type { Course, GPACalculationResult } from '@gpa-scales/shared-types';
import { AG_SUBJECT_LABELS } from '../data/agSubjectInfo';
import { GradeLevel, AGSubject } from '@gpa-scales/shared-types';

const GRADE_LEVEL_LABELS: Record<number, string> = {
  [GradeLevel.Freshman]: '9th',
  [GradeLevel.Sophomore]: '10th',
  [GradeLevel.Junior]: '11th',
  [GradeLevel.Senior]: '12th',
};

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function generateCSV(courses: Course[], result: GPACalculationResult): string {
  const BOM = '\uFEFF';
  const rows: string[][] = [];

  // Header
  rows.push(['Name', 'Grade', 'Level', 'Type', 'A-G Subject', 'Credits', 'Grade Points', 'Bonus', 'Included In']);

  for (let i = 0; i < courses.length; i++) {
    const course = courses[i];
    const contribution = result.contributions.find((c) => c.courseId === course.id);

    const includedVariants: string[] = [];
    if (contribution) {
      if (contribution.includedIn.unweighted) includedVariants.push('UW');
      if (contribution.includedIn.ucCapped) includedVariants.push('UC Cap');
      if (contribution.includedIn.ucUncapped) includedVariants.push('UC Uncap');
      if (contribution.includedIn.ucUnweighted) includedVariants.push('UC UW');
      if (contribution.includedIn.commonApp) includedVariants.push('CommonApp');
    }

    rows.push([
      escapeCSV(course.name),
      escapeCSV(course.grade),
      GRADE_LEVEL_LABELS[course.gradeLevel] ?? String(course.gradeLevel),
      course.courseType.toUpperCase(),
      course.agSubject === AGSubject.None ? 'N/A' : (AG_SUBJECT_LABELS[course.agSubject as keyof typeof AG_SUBJECT_LABELS] ?? course.agSubject),
      course.credits.toFixed(1),
      contribution ? contribution.gradePoints.toFixed(2) : '0',
      contribution ? contribution.bonusPoints.toFixed(1) : '0',
      includedVariants.join('; '),
    ]);
  }

  // GPA Summary section
  rows.push([]);
  rows.push(['GPA Summary']);
  rows.push(['Variant', 'GPA', 'Courses', 'Credits']);
  for (const variant of result.variants) {
    rows.push([
      escapeCSV(variant.label),
      variant.value.toFixed(3),
      `${variant.includedCourses}/${variant.totalCourses}`,
      variant.totalCredits.toFixed(1),
    ]);
  }

  const csv = rows.map((row) => row.join(',')).join('\n');
  return BOM + csv;
}
